import OutType from "../../enums/OutType.js";

// @see https://www.mlb.com/glossary/standard-stats/strikeout
// A strikeout occurs when a pitcher throws any combination of three swinging or looking strikes to a hitter. (A foul ball counts as a strike, but it cannot be the third and final strike of the at-bat. A foul tip, which is caught by the catcher, is considered a third strike.)
const classifiesAsStrikeout = function(outType) {
    switch (outType) {
        case OutType.Strikeout.key:
            return true;

        default:
            return false;
    }
};

export default classifiesAsStrikeout;